import { observer } from "mobx-react";
import ButtonBack from "newApp/components/ButtonBack";
import MainLayout from "newApp/components/layouts/MainLayout";
import Button from "newApp/kit/components/Button";
import ButtonsContainer from "newApp/kit/components/ButtonsContainer";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import InfoTable from "newApp/kit/components/InfoTable";
import TextArea from "newApp/kit/components/TextArea";
import { URL_SITE_TECHSUPPORT_NEW } from "newApp/routing/urls";
import { TechSupportNewItemPageStore } from "newApp/stores/pages/site/techsupport/TechSupportNewItemPageStore";
import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router";

const store = new TechSupportNewItemPageStore();

const TechSupportNewItemPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { push } = useHistory();

  useEffect(() => {
    store.init(id);
    return () => store.reset();
  }, [id]);

  const onClickAnswer = async () => {
    const result = await store.onAnswer();
    if (result) goOnList();
  };

  const goOnList = () => push(URL_SITE_TECHSUPPORT_NEW);

  return (
    <MainLayout>
      <H1>Ответ на вопрос пользователя сайта</H1>
      <FlexColumn>
        <ButtonBack url={URL_SITE_TECHSUPPORT_NEW}>
          Назад к списку вопросов
        </ButtonBack>
        <InfoTable
          content={[
            ["Дата", store.form.values.issueDate],
            ["Имя пользователя", store.form.values.fullname],
            ["Телефон пользователя", store.form.values.phone],
            ["Вопрос", store.form.values.text],
          ]}
        />
        <TextArea
          placeholder="Ответ пользователю"
          {...store.form.adapters.answer}
        />
        <ButtonsContainer>
          <Button onClick={onClickAnswer}>Ответить</Button>
          <Button onClick={goOnList} variant="secondary">
            Отменить
          </Button>
        </ButtonsContainer>
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(TechSupportNewItemPage);
